import { withFormik } from 'formik'

const FormikForm = (Component, formikObject) => {
  return withFormik(formikObject)(Component)
}

export default FormikForm
